import React, { useState } from "react";
import {
  Button,
  CustomInput,
  CustomSelect,
  Divider,
  FormFieldSet,
  InfoTimeCard,
  NewTable,
  PageHeader,
  PageTab,
  PageTitle,
  Tag,
  useFormHandler,
} from "../../../../../components";

import { mapTableRows } from "../../../../../utils";

import { useNavigate } from "react-router-dom";
import InvoicedetailsModal from "./Models/InvoicedetailsModal";
import { v4 as uuidv4 } from "uuid";

const EditWaitingforApprovalinvoic = ({ onBack }) => {
  const [model, setmodel] = useState(false);

  const handelinvoice = () => {
    setmodel(!model);
  };
  const { formData, errors, handleChange, setFormData, setErrors, validateAllFields } = useFormHandler({
    PayableCategory: "",
    PayableType: "",
    ApprovalFlow: "",
    InvoiceBy: "",
    Vendor: "",
    Contractors: "",
    MailingAddress: "",
    InvoiceNumber: "",
    NetTerms: "",
    BillDate: "",
    DueDate: "",
    BillAmount: "",
    InvoiceContacts: "",
    InvoiceContactEmails: "",
    discounts: [
      {
        id: uuidv4(),
        name: "",
        select: "",
        discount: "",
      },
    ],
    attachments: [
      {
        id: uuidv4(),
        comments: "",
        chooseFiles: [],
      },
    ],
  },{
    attachments: [ { chooseFiles: { type: "file" } } ],
  });
  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    setTableData2((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: newValue || "" } : row
      )
    );
  };

  const handleFieldChange = (index, field, value) => {
    handleChange(`attachments[${index}].${field}`, value);
  };
  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  const handleAddRow = () => {
    const newRow = {
      id: Date.now().toString(),
      documentType: "",
      invoiceOnBillRate: "",
      invoiceOnPayRate: "",
      receivedOnBillRate: "",
      receivedOnPayRate: "",
    };
    setTableData2((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (rowId) => {
    setTableData2((prev) => {
      const updatedRows = prev.filter((row) => row.id !== rowId);
      return updatedRows.length > 0 ? updatedRows : prev;
    });
  };

  const handleRemoveRowattach = (id) => {
    if (formData.attachments.length > 1) {
      // Find the index of the row to be removed
      const indexToRemove = formData.attachments.findIndex(
        (row) => row.id === id
      );

      // Update formData directly
      const newDocumentRows = formData.attachments.filter(
        (row) => row.id !== id
      );

      setFormData({
        ...formData,
        attachments: newDocumentRows,
      });

      // Update the errors state to remove errors for the deleted row
      if (errors?.attachments) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };

          if (newErrors.attachments) {
            // Remove the errors for the removed index
            const updatedRowErrors = [...newErrors.attachments];
            updatedRowErrors.splice(indexToRemove, 1);
            newErrors.attachments = updatedRowErrors;
          }

          return newErrors;
        });
      }
    }
  };
  const handleAddRowattach = () => {
    // Store current errors
    const currentErrors = { ...errors };

    // Update formData directly instead of using handleChange
    setFormData({
      ...formData,
      attachments: [
        ...formData.attachments,
        {
          id: uuidv4(),
          title: "",
          comments: "",
          status: "",
          expiryDate: "",
          chooseFiles: [],
        },
      ],
    });

    // Make sure to preserve errors
    setErrors(currentErrors);
  };




  const invoicePaymentColumns = [
    {
      key: "productService",
      label: "Product/Service",
      render: (row) => (
        <CustomInput
          type="text"
          title=" "
          placeholder="Enter Name"
          value={row.productService || ""}
          onChange={(value) =>
            handleRowChange(row.id, "productService", value)
          }
          size="xs"
        />
      ),
    },
    {
      key: " Description",
      label: " Description",
      render: (row) => (
        <CustomInput
          type="text"
          title=""
          placeholder="Enter  Description"
          value={row.Description || ""}
          onChange={(value) =>
            handleRowChange(row.id, " Description", value)
          }
          size="xs"
        />
      ),
    },
    {
      key: " Quantity",
      label: " Quantity",
      render: (row) => (
        <CustomInput
          type="text"
          title=""
          placeholder="Enter  Quantity"
          value={row.Quantity || ""}
          onChange={(value) =>
            handleRowChange(row.id, " Quantity", value)
          }
          size="xs"
        />
      ),
    },
    {
      key: " Rate",
      label: " Rate",
      render: (row) => (
        <CustomInput
          type="text"
          title=""
          placeholder="Enter  Rate"
          value={row.Rate || ""}
          onChange={(value) =>
            handleRowChange(row.id, " Rate", value)
          }
          size="xs"
        />
      ),
    },
    {
      key: "Amount",
      label: "Amount",
      render: (row) => (
        <CustomInput
          type="text"
          title=""
          placeholder="Enter Amount"
          value={row.Amount || ""}
          onChange={(value) =>
            handleRowChange(row.id, "Amount", value)
          }
          size="xs"
        />
      ),
    },
    {
      key: "Client",
      label: "Client",
      render: (row) => (
        <CustomSelect
          type="select"
          title=""
          placeholder="Select Placement"
          value={row.Client || ""}
          onChange={(value) => handleRowChange(row.id, "Client", value)}
          size="xs"
          options={[
            { value: "Placement 1", label: "Placement 1" },
            { value: "Placement 2", label: "Placement 2" },
            { value: "Placement 3", label: "Placement 3" },
          ]}
        />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={handleAddRow}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={() => handleRemoveRow(row.id)}
            disabled={tableData2.length <= 1}
          />
        </div>
      ),
    },
  ];
  const [tableData2, setTableData2] = useState([
    {
      id: 1,
      productService: "Website Development",
      Description: "Corporate website with CMS",
      Quantity: "1",
      Rate: "1500",
      Amount: "1500",
      Client: "Placement 1",
    },
    {
      id: 2,
      productService: "SEO Optimization",
      Description: "Monthly SEO services",
      Quantity: "2",
      Rate: "500",
      Amount: "1000",
      Client: "Placement 2",
    },
  ]);
  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: "",
        value: "",
      },
    ]);
  };

  const handleRemoveDiscount = (id) => {
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id)
      );
    }
  };
  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };


  const Documemtcolumns = [
    {
      key: "DocumentTitle",
      label: "Document Title",
    },
    {
      key: "Attachment",
      label: "Attachment",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },

  ]

  const documentrow = [
    {
      Attachment: "Deloitteinnvoice.pdf"
    }
  ]




  const mappedRows3 = mapTableRows(documentrow, Documemtcolumns);




  return (
    <div>
      <div>
        <PageHeader
          Section={
            <div className="flex gap-3">
            <PageTitle title={"Edit Accounts Payable"} tag="h5" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={onBack}
              />
              <Button size="sm" title={"Available Credits"} />
            </div>
          }
        />
      </div>
      <div className="grid grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="select"
          title=" Payable Category"
          placeholder="select Payable Category"
          value={formData.PayableCategory}
          onChange={(value) => handleChange("PayableCategory", value)}
          error={errors.PayableCategory}
        />
        <FormFieldSet
          type="select"
          title=" Payable Type"
          placeholder="select PayableType"
          value={formData.PayableType}
          onChange={(value) => handleChange("PayableType", value)}
          error={errors.PayableType}
        />
        <FormFieldSet
          type="text"
          title=" Approval Flow"
          placeholder="Enter  Approval Flow"
          value={formData.ApprovalFlow}
          onChange={(value) => handleChange("ApprovalFlow", value)}
          error={errors.ApprovalFlow}
        />
        <div>
          <InfoTimeCard
            title=" Balance Due"
            color="primary"
            value={"147833.72"}
            suffix={"USD"}
            type2
          />
        </div>
        <FormFieldSet
          type="select"
          title=" Invoice By"
          placeholder="Select Invoice By"
          value={formData.InvoiceBy}
          onChange={(value) => handleChange(" InvoiceBy", value)}
          error={errors.InvoiceBy}
        />
        <FormFieldSet
          type="select"
          title=" Vendor"
          placeholder="select Vendor"
          value={formData.Vendor}
          onChange={(value) => handleChange("Vendor", value)}
          error={errors.Vendor}
        />
        <FormFieldSet
          type="text"
          title="Contractors"
          placeholder="Enter Contractors"
          value={formData.Contractors}
          onChange={(value) => handleChange("Contractors", value)}
          error={errors.Contractors}
        />
        <div></div>
        <FormFieldSet
          type="textArea"
          title=" Mailing Address"
          placeholder="Enter Mailing Address"
          value={formData.MailingAddress}
          onChange={(value) => handleChange("MailingAddress", value)}
          error={errors.MailingAddress}
        />
        <div></div>
        <div></div>
        <div></div>
        <FormFieldSet
          type="text"
          title=" Invoice Number"
          placeholder=" Invoice Number"
          value={formData.InvoiceNumber}
          onChange={(value) => handleChange("InvoiceNumber", value)}
          error={errors.InvoiceNumber}
          required
        />
        <FormFieldSet
          type="select"
          title=" Net Terms"
          placeholder="select Net Terms"
          value={formData.NetTerms}
          onChange={(value) => handleChange("NetTerms", value)}
          error={errors.NetTerms}
        />
        <div></div>
        <div></div>
        <FormFieldSet
          type="datepicker"
          title=" Bill Date"
          placeholder="Bill Date"
          value={formData.BillDate}
          onChange={(value) => handleChange("BillDate", value)}
          error={errors.BillDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title=" Due Date"
          placeholder="DueDate"
          value={formData.DueDate}
          onChange={(value) => handleChange("DueDate", value)}
          error={errors.DueDate}
          showDropdown={false}
        />
        <div></div>
        <div></div>
        <FormFieldSet
          type="text"
          title=" Bill Amount"
          placeholder="Enter  Bill Amount"
          value={formData.BillAmount}
          onChange={(value) => handleChange("BillAmount", value)}
          error={errors.BillAmount}
          required
        />
        <FormFieldSet
          type="text"
          title="Invoice Contacts"
          placeholder="Enter ConInvoice Contactstractors"
          value={formData.InvoiceContacts}
          onChange={(value) => handleChange("InvoiceContacts", value)}
          error={errors.InvoiceContacts}
        />
        <FormFieldSet
          type="text"
          title=" Invoice Contact Emails"
          placeholder="Enter  Invoice Contact Emails"
          value={formData.InvoiceContactEmails}
          onChange={(value) => handleChange("InvoiceContactEmails", value)}
          error={errors.InvoiceContactEmails}
        />
      </div>
      <div className="flex items-center justify-between mt-5">
        <p> Invoice Details</p>
        <Button
          size="sm"
          title="Add"
          onClick={handelinvoice}
          color="black"
          icon="add"
        />
      </div>
      <Divider />
      <NewTable
        columns={invoicePaymentColumns}
        rows={tableData2}
        hideToolBar
        showSlNo={true}
      />
      <div>
        <InvoicedetailsModal open={model} onClose={() => setmodel(!model)} />
      </div>
      <div className="flex items-center justify-between mt-5">
        <p>Notes & Total</p>
      </div>
      <Divider />
      <div className="mt-2">
        <div className="flex flex-col  items-end">
          <div className="flex items-center gap-2">
            Subtotal:
            <div className="bg-black text-white pl-3 pr-2 py-2">
              9600.00 USD
            </div>
          </div>
          <div className="flex flex-col   gap-4">
            {formData.discounts.map((discount) => (
              <div key={discount.id} className="flex  gap-6 mt-3">
                <div className="flex-1">
                  <FormFieldSet
                    type="text"
                    noTitle={true}
                    value={discount.name}
                    placeholder="Name"
                    onChange={(value) =>
                      handleDiscountFieldChange(discount.id, "name", value)
                    }
                  />
                </div>
                <div className="flex-1">
                  <FormFieldSet
                    type="select"
                    noTitle={true}
                    value={discount.type}
                    placeholder="Select"
                    onChange={(value) =>
                      handleDiscountFieldChange(discount.id, "type", value)
                    }
                  />
                </div>
                <div className="flex-1">
                  <FormFieldSet
                    type="text"
                    title=""
                    placeholder="Discount"
                    noTitle={true}
                    value={discount.value}
                    onChange={(value) =>
                      handleDiscountFieldChange(discount.id, "value", value)
                    }
                  />
                </div>
                <div className="mt-3 flex gap-2">
                  <Button
                    type="icon"
                    icon="add"
                    size="xs"
                    color="black"
                    onClick={handleAddDiscount}
                  />
                  <Button
                    type="icon"
                    icon="remove"
                    size="xs"
                    color="danger"
                    onClick={() => handleRemoveDiscount(discount.id)}
                  />
                </div>
                <div className="text-gray-600 mt-3">0.00 USD</div>
              </div>
            ))}
          </div>
          <div className="flex gap-2 mt-3">
            discount Total:
            <div>0000.00 USD</div>
          </div>
          <div className="min-w-72 ">
            <Divider />
            <div className="flex justify-end ">
              <p>
                Grand Total <span className="ml-7">9600.00 </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="textArea"
          title="Comments"
          placeholder="Enter Comments"
          value={formData.Comments}
          onChange={(value) => handleChange("Comments", value)}
          error={errors.Comments}
        />
        <FormFieldSet
          type="textArea"
          title=" Statment Memo"
          placeholder="Enter Mailing Address"
          value={formData.StatmentMemo}
          onChange={(value) => handleChange("StatmentMemo", value)}
          error={errors.StatmentMemo}
        />
      </div>
      <div className="flex items-center justify-between mt-5">
        <p>Documents</p>
      </div>
      <Divider />
      <div>
        {formData.attachments.map((row, index) => (
          <div key={row.id} className="flex gap-4 px-1 py-4 max-w-3xl">
            <div className="flex-1">
              <FormFieldSet
                type="text"
                placeholder="Title"
                title={""}
                value={row.title}
                onChange={(value) => handleFieldChange(index, "title", value)}
                error={getAttachmentError(index, "title")}
              />
            </div>
            <div className="flex-1 flex items-start gap-2 ">
              <FormFieldSet
                type="file"
                title=""
                placeholder="Choose File"
                value={row.chooseFiles}
                onChange={(value) =>
                  handleFieldChange(index, "chooseFiles", value)
                }
                error={getAttachmentError(index, "chooseFiles")}
              />
              <div className="flex gap-2 mt-8">
                <Button
                  type="icon"
                  size="xs"
                  icon="add"
                  color="black"
                  onClick={handleAddRowattach}
                />
                <Button
                  type="icon"
                  size="xs"
                  icon="remove"
                  color="danger"
                  onClick={() => handleRemoveRowattach(row.id)}
                  disabled={formData.attachments.length === 1}
                />
              </div>
            </div>
          </div>
        ))}
        <div>
          <NewTable
            showCheckbox
            rows={mappedRows3}
            columns={Documemtcolumns}
            hideToolBar
          />
        </div>
      </div>
      <div className="grid grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type=" "
          title="Comments"
          placeholder="Enter Comments"
          value={formData.Comments}
          onChange={(value) => handleChange("Comments", value)}
          error={errors.Comments}
        />
      </div>
      <div className="flex gap-3 justify-center my-6">
        <Button title="Cancel" variant="outlined" onClick={""} />
        <Button title="Proceed" onClick={""} />
      </div>
    </div>
  );
};

export default EditWaitingforApprovalinvoic;
